import { environment } from 'src/environments/environment';

export class AuthLogger {
    private static readonly PREFIX = '[Auth]';

    static log(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.log(`${this.PREFIX} ${message}`, ...args);
        }
    }

    static error(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.error(`${this.PREFIX} ${message}`, ...args);
        }
    }

    static warn(message: string, ...args: any[]): void {
        if (!environment.production) {
            console.warn(`${this.PREFIX} ${message}`, ...args);
        }
    }
}